module.exports = __webpack_public_path__ + "img/photo-4.0bcb02fd.jpg";